import * as PickerIcons from '.';
import { PickerIconsEnum } from '../constants';

const parsePickerIcon = (value: string): PickerIconsEnum | null => {
  return Object.values(PickerIconsEnum).find((icon) => icon === value) ?? null;
};

export const getPickerIcon = (type: string): JSX.Element | null => {
  const pickerIcon = parsePickerIcon(type);
  if (!pickerIcon) {
    return null;
  }
  const IconComponent = PickerIcons[`${pickerIcon}Icon`];
  const spacedStr = pickerIcon
    .replaceAll('_', ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase();
  const tooltip = spacedStr.charAt(0).toUpperCase() + spacedStr.slice(1);
  return <IconComponent tooltip={tooltip} />;
};
